import React from 'react';
import './SliderRow.css';

class SliderRow extends React.Component {
  render() {
    return <div className="row">
      <p className="label">{this.props.label}</p>
      <p className="value">{this.props.value}</p>
      <p className="slider">
      <input name={this.props.name} type="range" value={this.props.value} onChange={this.props.slideHandler} min={this.props.min} max={this.props.max} step={this.props.step} />
      </p>
      </div>
  }
}

export default SliderRow;
